import { Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { GenericInfoSchemaType } from '../../schema/input'
import FileUpload from '../forms/FileUploadWrapper'
import MultipleUpload from '../forms/MultipleUploadWrapper'
import SelectDate from '../forms/SelectDateWrapper'

type Props = {
  city?: string
  dir: string
  hasExpirationDate: boolean
  value: GenericInfoSchemaType
}

const GenericDocs = ({ city, dir, hasExpirationDate, value }: Props) => {
  const { t } = useTranslation()

  const configGridItem = {
    item: true,
    xs: 12,
  }

  // Check if this document type supports multiple uploads
  const supportsMultipleUploads = ['background', 'licensing'].includes(dir)

  return (
    <Grid
      container
      rowGap={4}
      sx={{
        backgroundColor: '#FAF9F9',
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        mb: 2,
        p: 4,
      }}
    >
      {hasExpirationDate && (
        <Grid {...configGridItem}>
          <SelectDate
            label={t('documents.additional_documents.expiration_date')}
            name="docExpirationDate"
          />
        </Grid>
      )}
      <Grid {...configGridItem}>
        {supportsMultipleUploads ? (
          <MultipleUpload
            city={city}
            documentType="document"
            folder={dir}
            label={t('documents.additional_documents.document')}
            name="document"
          />
        ) : (
          <FileUpload
            city={city}
            documentType="document"
            fileName={dir}
            folder={dir}
            label={t('documents.additional_documents.document')}
            name="document"
            value={value.document}
          />
        )}
      </Grid>
    </Grid>
  )
}

export default GenericDocs
